import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/web-commerce/layouts/default.vue").then(m => m.default || m))
}